var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',{staticClass:"mgb10",attrs:{"title":"7天销售趋势"}},[_c('ve-line',{attrs:{"data":_vm.theadData,"extend":_vm.extend}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }